<template>
    <div style="color: black;">
        <div style="font-size: 16px; padding: 15px 0 15px 15px; display: inline-block;">
            I am looking for
        </div>
        <v-radio-group
            v-model="select"
            style="max-width: 500px; display: inline-block; vertical-align: -2px; height: 60px; margin-left: 8px;"
            row
            dense
            hide-details
            @change="handleSelection"
        >
            <v-chip
                v-if="select === 'Hospital'"
                color="success"
                label
                pill
                style="border-radius: 9999px !important; margin: 0; padding: 0 2px; color: white"
            >
                <v-radio
                    value="Hospital"
                    color="white"
                >
                    <template slot="label">
                        <span style="color: white;">Hospital</span>
                    </template>
                </v-radio>
            </v-chip>
            <v-radio
                v-else
                label="Hospital"
                value="Hospital"
                color="success"
            />
            <v-chip
                v-if="select === 'Clinic'"
                color="success"
                label
                rounded
                pill
                style="border-radius: 9999px !important; margin: 0; padding: 0 2px"
            >
                <v-radio
                    label="Clinic"
                    value="Clinic"
                    color="white"
                >
                    <template slot="label">
                        <span style="color: white;">Clinic</span>
                    </template>
                </v-radio>
            </v-chip>
            <v-radio
                v-else
                label="Clinic"
                value="Clinic"
                color="success"
            />
            <v-chip
                v-if="select === 'Doctor'"
                color="success"
                label
                pill
                style="border-radius: 9999px !important; margin: 0; padding: 0 2px"
            >
                <v-radio
                    label="Doctor"
                    value="Doctor"
                    color="white"
                >
                    <template slot="label">
                        <span style="color: white;">Doctor</span>
                    </template>
                </v-radio>
            </v-chip>
            <v-radio
                v-else
                label="Doctor"
                value="Doctor"
                color="success"
            />
        </v-radio-group>
    </div>
</template>

<script>
export default {
    data: ()=>({
        select: 'Hospital',
        choices: ['Hospital', 'Clinic', 'Doctor']
    }),
    methods: {
        handleSelection(type) {
            this.$emit('handleSelection', type)
        }
    }
}
</script>
